export default "__VITE_ASSET__DCT5D1Rs__"